import { memo } from 'react';
import { SicBoRoadmapRecord } from '../../../../models/games/sicbo';
import { useSicBoRoadMapCellColorText } from '../hook';

const SicBoOddEvenRoadCell = ({
    size,
    OddEventRResult,
}: {
    size: number;
    OddEventRResult: SicBoRoadmapRecord['OddEventRResult'];
}) => {
    const { color, text } = useSicBoRoadMapCellColorText(OddEventRResult);
    return (
        <>
            <svg width={size} height={size}>
                {OddEventRResult !== '' && (
                    <>
                        <rect
                            width={size}
                            height={size}
                            style={{
                                fill: color,
                            }}
                        />
                        <text
                            x={size / 2}
                            y={size / 2 + 1}
                            textAnchor="middle"
                            dominantBaseline="middle"
                            fill="#ffffff"
                            fontSize={size * 0.9}
                            fontWeight={'bold'}
                        >
                            {text}
                        </text>
                    </>
                )}
            </svg>
        </>
    );
};

export default memo(SicBoOddEvenRoadCell);